// TOUT sur clairify.fr - app.clairify.fr n'existe plus
export const DOMAIN_TYPES = {
 PRODUCTION: 'production',
 LOCAL: 'local'
} as const;

export function getDomainType(): string {
 const hostname = window.location.hostname;
 if (hostname === 'localhost' || hostname === '127.0.0.1') return DOMAIN_TYPES.LOCAL;
 return DOMAIN_TYPES.PRODUCTION; // Tout le reste = clairify.fr
}

export function getStudioUrl(): string {
 // Toujours route locale - TOUT est sur clairify.fr
 return '/studio';
}

export function getLoginUrl(): string {
 // Toujours route locale - TOUT est sur clairify.fr
 return '/login';
}

export function isLandingDomain(): boolean {
 // Obsolète
 return false;
}

export function isAppDomain(): boolean {
 // Obsolète
 return true;
}

